import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Carousel from '../../ui/Carousel';
import Tag from '../../ui/Tag';
import ReadMore from '../../ui/ReadMore';
import DownloadButton from '../../ui/DownloadButton';
import LinkButton from '../../ui/LinkButton';
import BrandLogo from '../../ui/BrandLogo';
import style from './CatalogPreview.module.scss';
import useWindowResize from '../../hook/UseWindowResize';
import { useTranslation } from 'react-i18next';
import useReactiveMessage from '../../hook/UseReactiveMessage';

const CatalogPreview = (props) => {

  let {
    catalog = {},
  } = props;

  let {
    title,
    subtitle,
    description,
    brandImageUrl,
    brandName,
    companyPageUrl,
    type,
    fileSize,
    catalogPageUrl,
    companyContractDisplayId,
    companyId,
    catalogId,
    documentId,
    pages = [],
  } = catalog;

  let { windowWidth } = useWindowResize();
  const { t } = useTranslation(['catalog']);
  const {sendMessage} = useReactiveMessage('CATALOG_DOWNLOAD_CLUEZ');

  const blockButton = (width) => {
    return width <= 769;
  };

  const onClickDownload = () => {
    sendMessage({
      companyContractDisplayId,
      companyId,
      catalogId,
      documentId,
      catalogPreview: true,
    });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6 mb-3 p-0">
          <Carousel items={pages}/>
        </div>
        <div className={clsx('col-md-6', style.CatalogDesc)}>
          <h4 className="ttl fs-2 mb-3 font-weight-bold" id="previewCatalogTitle">{title}</h4>
          <div className={clsx('mb-3', style.CatalogPreviewCompanyInfo)}>
            <BrandLogo name={brandName} imageUrl={brandImageUrl} pageUrl={companyPageUrl}/>
          </div>
          <div className="mb-3" id="previewCatalogType">
            <Tag name={type}/>
          </div>
          <div className="txt font-weight-bold mb-3" id="previewCatalogSubtitle">{subtitle}</div>

          <div className="mb-3 preview-description">
            <ReadMore text={description} line="4" more={t('catalog.preview.more')} less={t('catalog.preview.less')}></ReadMore>
          </div>

          <div className="btn-wrap">
            <DownloadButton size={fileSize} block={blockButton(windowWidth)} onClick={onClickDownload} />
            <LinkButton label={t('catalog.preview.page')} href={catalogPageUrl} block={blockButton(windowWidth)} />
          </div>
        </div>
      </div>
    </div>
    /* <div className={style.CatalogPreview}>
      <div className={style.carousel}><Carousel items={pages}/></div>
      <div className={style.info}>
        <h4 className={style.title}>{title}</h4>
        <div className={'mb-3'}>
          <BrandLogo name={brandName} imageUrl={brandImageUrl}/>
        </div>
        <div className={'mb-3'}>
          <Tag name={type}/>
        </div>

        <div className={style.subtitle}>{subtitle}</div>

        <div className={'mb-3'}>
        <div className={style.desc}>
          <ReadMore text={description} more={t('catalog.preview.more')} less={t('catalog.preview.less')}></ReadMore>
        </div>
        <div className={style.buttons} style={{flexDirection: blockButton(windowWidth)?'column':'row'}}>
          <div className={'catalogDownloadLink'}>
        <DownloadButton  size={fileSize} block={blockButton(windowWidth)} onClick={onClickDownload} />
          </div>
        <LinkButton label={t('catalog.preview.page')} href={catalogPageUrl} block={blockButton(windowWidth)} />
        </div>
      </div>
    </div> */
  )

};

CatalogPreview.propTypes = {
  catalog: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
    brandName: PropTypes.string,
    brandImageUrl: PropTypes.string,
    fileSize: PropTypes.string,
    catalogPageUrl: PropTypes.string,
    companyContractDisplayId: PropTypes.number,
    companyId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    catalogId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    pages: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      imageUrl: PropTypes.string,
    })),
  }),
};

export default CatalogPreview;
